import Meta from '../common/Meta'
import classes from './Performance.module.css'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import { Page } from '../widgets/Page'
import RowContainer from '../stories/RowContainer/RowContainer'
import { Outlet, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import Tabs from '../stories/Tabs/Tabs'
import Header from '../common/components/header/Header'
import { useCompetitionId } from '../common/hooks'

export default function Performance() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const location = useLocation()
  const [activeTab, setActiveTab] = useState<string>('')
  const competition_id = useCompetitionId()
  const tabs = [
    {
      value: 'analysis',
      label: 'Analysis',
    },
    {
      value: 'kpi',
      label: 'KPI Rank',
    },
  ]

  useEffect(() => {
    const path = location.pathname.split('/performance/')[1]
    const firstSegment = path?.split('/')[0] ?? ''
    setActiveTab(firstSegment)
  }, [location])

  return (
    <Page
      path={'/performance'}
      context={{
        subject_type: 'overall',
        period_type: 'year',
        competition_id: competition_id,
      }}
    >
      <div className={classes.container}>
        <Meta title="Performance" />
        <Header title="Performance" withUpdate />
        <div
          className={clsx(classes.performance_wrapper, {
            [classes.performance_wrapper_mobile]: !isDesktop,
          })}
        >
          <RowContainer isTransparent>
            <Tabs
              items={tabs}
              value={activeTab}
              onChange={setActiveTab}
              isLink
              isLarge
            />
          </RowContainer>
          <Outlet />
        </div>
      </div>
    </Page>
  )
}
